<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent">
        <b-row>
            <b-col>
                <div style="background: rgb(251, 251, 251); padding: 5px 32px 4px;border-bottom: 1px solid gray; ">
                </div>
            </b-col>
        </b-row>
        <b-row style="padding-top: 45px; padding-left: 30px; padding-right: 30px">
            <b-col md="6" style="max-height: 70vh; min-height: 70vh; overflow: auto">
                <b-table striped hover selectable
                         :items="groups"
                         :fields="group_fields"
                         select-mode="single"
                         selectedVariant="primary"
                         @row-selected="rowSelectedGroup"
                         ref="group_table">
                    <template v-slot:cell(is_active)="row">
                        <b-form-checkbox size="lg" v-model="row.item.is_active" @change="changed($event, row.item)"></b-form-checkbox>
                    </template>
                </b-table>
            </b-col>

            <b-col md="6" style="max-height: 80vh; min-height: 70vh; overflow: auto">
                <b-table striped :items="objects" :fields="object_fields"
                         ref="object_table"
                >
                    <template v-slot:cell(is_active)="row">
                        <b-form-checkbox size="lg" v-if="!currentGroup.is_active" disabled></b-form-checkbox>
                        <b-form-checkbox size="lg" v-if="currentGroup.is_active" v-model="row.item.is_active" @change="changed($event, row.item)"></b-form-checkbox>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";

    export default {
        name: "AugrAndWork",
        data() {
            return {
                loader: undefined,
                currentGroup: {},
                groups: [],
                objects: undefined,
                objectsMap: {},
                group_fields: [{key: "s_value", label: 'Auftragsgruppe'}, {key: "is_active", label: "Aktiv ?"}],
                object_fields: [{key: "s_value", label: 'Stammauftrag'}, {key: "is_active", label: "Aktiv ?"}],
                selected: [],

            }
        },
        mounted() {
            this.showLoader();
                this.$http.get(
                    Server_URL + '/baumkontrolle/config/schluessel_augr_work'
                ).then(this.responseOkGet, this.responseError)
        },
        methods: {
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    for (let i = response.body.augr.length-1; i >= 0; i--) {
                        if (response.body.augr_map[response.body.augr[i].s_value] === undefined) {
                            response.body.augr.splice(i, 1)
                        }
                        this.groups = response.body.augr;
                        this.objectsMap = response.body.augr_map;
                    }
                } else {
                    console.log(response);
                }
            },
            rowSelectedGroup(items) {
                if (items.length === 0) {
                    this.objects = undefined;
                    this.selected = [];
                    this.currentGroup = {};
                } else {
                    this.objects = this.objectsMap[items[0].s_value];
                    this.currentGroup = items[0];
                }
            },
            changed(isActive, schluessel) {
                if (schluessel.id !== -1) {
                    this.$http.patch(
                        Server_URL+'/baumkontrolle/config/schluessel/'+schluessel.id+"?active=" + (Boolean(isActive)).toString()
                    ).then(this.responseOkTrap, this.responseError);
                }
            },
            responseOkTrap(response) {
                if (response.status === 200) {
                } else {
                    console.log(response);
                }
            },
        }
    }
</script>

<style scoped>

</style>
